import { ClientEvents } from 'common/events/ClientEvents';
import { MealPlanFoodItem } from 'src/pages/consumer/meal-plans/checkout/types';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { useShare } from 'src/shared/hooks/useShare';
import { useTracker } from 'src/shared/hooks/useTracker';
import { getReferralUrl } from 'src/shared/utils/PromoUtilities';

export const useShareDish = (foodItem: MealPlanFoodItem) => {
  const { publicName, id: shefId } = foodItem.shef;
  const [currentUser] = useCurrentUser();
  const tracker = useTracker();

  const { referralCode } = currentUser ?? {};
  const { code } = referralCode ?? {};

  const shareDishUrl = getReferralUrl({
    code: code ?? '',
    shefId,
    foodItemSlug: foodItem.slug ?? undefined,
  });

  const onShare = () => {
    tracker.track(ClientEvents.SHARE_SHEF_FOOD_ITEM, {
      foodItemId: foodItem.id,
      shefId,
    });
  };

  const { share, copied } = useShare({
    url: shareDishUrl,
    onShare,
    onError: () => console.error('Failed to share'),
    shareMessage: `Check out ${foodItem.name} by Shef ${publicName} on Shef!`,
  });

  return { share, copied };
};
